import { useQuery } from "@apollo/client";
import { FETCH_DOCUMENT_SUMMARY } from "@documents/graphql/queries/fetchDocumentSummary";

export const useDocumentSummary = (documentId: string, skipQuery = false) => {
    const { data, loading, error } = useQuery(FETCH_DOCUMENT_SUMMARY, {
        variables: { documentId },
        skip: skipQuery || !documentId
    });
    
    return {
        summary: data?.documentSummary,
        loading,
        error
    };
}; 